export const setAuthHeader = (token: string | null): Headers => {
  const headers = new Headers();
  headers.append('Cache-Control', 'no-cache');
  headers.append('Content-Type', 'application/json');

  if (
    checkIfPwa() &&
    localStorage.getItem('pwa-instance-id') &&
    localStorage.getItem('pwa-instance-id') !== 'undefined'
  ) {
    const pwaInstanceId = localStorage.getItem('pwa-instance-id');
    if (pwaInstanceId) {
      headers.append('pwa-instance-id', pwaInstanceId);
    }
  }

  // determine if a token was provided
  if (token !== null) {
    // set the authorization header
    headers.set('Authorization', 'Bearer ' + token);
  }

  return headers;
};

export const setAuthHeaderWithCustomData = (
  token: string | null,
  customHeaderData: { key: string; value: string },
): Headers => {
  const headers = setAuthHeader(token);

  if (customHeaderData != null) {
    // set the authorization header with key, value
    headers.set(customHeaderData.key, customHeaderData.value);
  }

  return headers;
};

export const setAuthHeaderForFormData = (token: string | null): Headers => {
  const headers = new Headers();
  headers.append('Cache-Control', 'no-cache');

  // determine if a token was provided
  if (token !== null) {
    // set the authorization header
    headers.set('Authorization', 'Bearer ' + token);
  }

  return headers;
};

export function GetToken(user: string) {
  let token = '';
  if (user.trim() !== '') {
    const userDetails = localStorage.getItem(user);
    const userJson = userDetails ? JSON.parse(userDetails) : userDetails;
    token = userJson ? userJson.access_token : userJson;
  }

  return token;
}

function parseJwt() {
  const token = GetToken('user');
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export function GetParsdToken() {
  const parsedToken = parseJwt();

  return parsedToken;
}

const checkIfPwa = (): boolean => {
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }
  return false;
};
